<template>
  <div
    class="columns has-padding-left-110-desktop has-padding-right-120-desktop is-multline"
  >
    <div class="column is-12 has-background-white">
      <div class="columns is-multiline">
        <div class="column is-12 pb-0 px-0">
          <img src="@/static/images/sipfaqcover.png" alt="" />
        </div>
      </div>

      <div
        class="columns is-multiline has-padding-right-60-desktop has-padding-left-50-desktop has-padding-left-20-mobile has-padding-right-30-mobile is-vcentered is-mobile"
      >
        <div class="column is-4 is-bottom-paddingless">
          <img height="140" width="140" src="@/static/images/seep.svg" alt="" />
        </div>
        <div class="column is-4 is-bottom-paddingless has-text-centered">
          <img
            height="200"
            width="200"
            src="@/static/images/brand/logo.svg"
            alt=""
          />
        </div>
        <div class="column is-4 has-text-right is-bottom-paddingless">
          <img height="60" width="60" src="@/static/images/ukaid.png" alt="" />
        </div>

        <div
          v-if="$route.path === '/en/sep-faqs'"
          class="column is-12 py-0 px-10 is-size-5-desktop is-size-6-mobile has-text-weight-bold has-text-centered"
        >
          अब देशमै छ रोजगारी Campaign: Frequently Asked Questions (FAQs)
        </div>
        <div
          v-else
          class="column is-12 py-0 px-10 is-size-4-desktop is-size-6-mobile has-text-weight-bold has-text-centered"
        >
          अब देशमै छ रोजगारी अभियान: बारम्बार सोधिने प्रश्नहरू
        </div>
      </div>
      <hr class="mb-0 mt-0" />
      <div
        v-if="$route.path === '/en/sep-faqs'"
        class="columns is-multiline has-padding-left-60-desktop has-padding-right-60-desktop has-padding-left-30-mobile has-padding-right-30-mobile has-padding-top-20 has-padding-bottom-10"
      >
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            What is ‘अब देशमै छ रोजगारी’ Campaign and who is it targeted at?
          </div>
          <div class="is-size-8 has-text-justified">
            ‘अब देशमै छ रोजगारी’ Campaign, launched on July 30, 2020, is a
            market-led initiative designed and implemented by Rojgari Services
            and UKaid Skills for Employment Programme (सीप), to reach, register,
            and respond to the livelihood needs of migrant returnees and other
            economically disadvantaged, socially excluded groups. The two
            specific goals include:
          </div>
          <div class="is-size-8 has-text-justified pl-4">
            <ul style="list-style-type: disc">
              <li>
                Register migrant returnees via Rojgari Service’s
                <a target="_blank" href="https://rojgari.com/">web</a> and
                mobile applications (search Rojgari on Play/App store) to build
                a database of job seekers who can be counseled and connected to
                gainful employment/self-employment opportunities.
              </li>
              <li>
                Develop a stronger ecosystem, with deeper collaborations forged
                with and between the Government of Nepal, industries/employers,
                cooperatives, training providers, financial institutes, civil
                society, and others, to improve access to quality, affordable
                skilling, job, financing, and enterprise start-up opportunities
                and propel economic growth.
              </li>
            </ul>
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            The primary target audience for the Campaign are job seekers,
            especially migrants who have returned back in Provinces 2 and 5, and
            those facing imminent return once international borders open up.
            Equally important, the Campaign is also targeted at the ecosystem
            stakeholders -- Government of Nepal, employers/industries, financial
            institutions, training providers, enterprise start-up service
            providers, media/influencers, NGOs -- who have the capabilities and
            incentive to support and engage migrant returnees.
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            The Campaign is designed to inform and attract migrant returnees to
            decent jobs/self-employment/entrepreneurship opportunities in Nepal,
            and for the private sector and the Government – with support from
            partners like Rojgari Services and सीप – to collaborate in both
            creating and informing job seekers of those livelihood
            opportunities. Through the slogan ‘अब देशमै छ रोजगारी’ our hope to
            inspire and build the trust and confidence needed for migrant
            returnees to consider domestic employment, and for
            industries/employers to recognize the value that Rojgari Services
            can add, and to join hands. Our goal is to catalyze a collective
            movement for increased job creation and enterprise growth – for and
            by Nepal’s human resources.
          </div>
        </div>

        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            Why is the अब देशमै छ रोजगारी campaign needed?
          </div>
          <div class="is-size-8 has-text-justified">
            Around 700,000 Nepali workers are estimated to return from overseas
            employment over the next year alone. Many are returning after
            months, having spent most of their savings and very little idea of
            what lies ahead. Nepal, by one estimate, needs to create 1.5 million
            jobs to avoid an imminent unemployment crisis. The Government,
            together with the private sector, is faced with the unprecedented
            need to swiftly put in place mechanisms that can position the large
            number of returnee migrants into gainful employment/self-employment.
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            Our individual and collective inability to do so, in time, may have
            an adverse impact across all sectors of the economy, reversing
            hard-won progress of recent decades. The Campaign, therefore, seeks
            to build the collaborations needed to strengthen the ecosystem and
            support services required to reach and encourage migrant returnees
            to register, so that we are, as a country, able to extend the
            'न्यानो स्वागत' that they so rightly deserve. In doing so, ensuring
            that we are, together, able to leverage our human capital to propel
            the growth of the country's citizens, enterprises, and economy.
          </div>
        </div>

        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            How will the Campaign reach returnee migrants?
          </div>
          <div class="is-size-8 has-text-justified">
            Using a multi-channel, integrated communications and livelihood
            Campaign, we will counsel and connect semi-skilled and skilled
            migrant returnees and others with a diverse set of partners. The
            Campaign builds on and seeks to strengthen Rojgari Service’s
            networks and services to ensure it reaches as many from the target
            group.
          </div>
          <div class="is-size-8 has-text-justified pl-4">
            <ul style="list-style-type: disc">
              <li>
                <b>Digital Engagement and Media Outreach</b> – Facebook (<a
                  target="_blank"
                  href="https://www.linkedin.com/company/rojgari-services-pvt-ltd/"
                  >Rojgari Services</a
                >
                ,
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/ukaid-skills-for-employment-programme-%E0%A4%B8%E0%A5%80%E0%A4%AA/?originalSubdomain=np"
                  >UKaid सीप</a
                >, other collaborators), Youtube Ads, Viber, Online Media,
                Webinars/Discussions (Facebook and Linkedin), Tiktok, as well
                radio and print media.
              </li>
              <li>
                <b>Engaging Influencers</b> such as Dhurmus and Suntali to
                endorse and share the Campaign through their public platforms.
              </li>
              <li>
                <b>Engage Champions</b> in destination countries in
                collaboration with NGOs such as Pourakhi Nepal, Pravasi Nepali
                Coordination Committee, Aaprabasi Mahila Kamdar Samuha to orient
                and facilitate registration by migrants aboard.
              </li>
              <li>
                <b>Engage Collaborators</b> in the private sector, Government,
                media, and civil society to endorse and amplify the Campaign
                through their public platforms e.g., showrooms, offices, ATMs,
                social media platforms, media articles, etc.
              </li>
              <li>
                <b>Ghumti Rojgari Pasal</b>, a mobile employment shop, launched
                by सीप and Rojgari Services will continue to travel to nook and
                corners of rural Nepal sensitizing job seekers and registering
                them. Priority will remain in P2 and P5.
              </li>
              <li>
                Rojgari Services also has <b>Rojgari Pasals</b> in Birgunj,
                Nepalgunj, Kathmandu, Pokhara, and Itahari. These employment
                shops will continue to conduct outreach to and engage with job
                seekers and employers alike.
              </li>
            </ul>
          </div>
        </div>

        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            How is the Campaign aligned with and complementary to the efforts of
            the Government of Nepal?
          </div>
          <div class="is-size-8 has-text-justified">
            The ‘अब देशमै छ रोजगारी Campaign is designed to support the people,
            institutions, and the Government of Nepal in catalyzing a collective
            movement to generate more jobs, spark enterprises, and facilitate
            socio-economic growth. Rojgari Services and सीप, since 2019, are
            working to build meaningful collaborations with the Government of
            Nepal, especially with Provincial governments, municipalities, local
            wards, and Employment Service Centers (ESCs) of Province 5 and 2.
            For instance, Rojgari Service’s registration portal, and individuals
            registered thereof, will be linked to support/services available
            from the Government. Similarly, Rojgari Services will also request
            and encourage ESCs to register job seekers who come their way via
            Rogjari’s web and mobile applications to connect them to private
            sector-led skilling and job opportunities.
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            At the federal-level, the campaign will integrate and work alongside
            the Ministry of Labor, Employment, and Social Security and other
            related GoN programmes to support the country’s vision and efforts
            in job creation for migrant returnees.
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            Are there enough jobs in the country for Rojgari Services, सीप, and
            other partners to deliver on the Campaign?
          </div>
          <div class="is-size-8 has-text-justified">
            Over the last month alone, Rojgari has collected nearly 9,000
            jobs/demands. Most of these are located in Kathmandu, Ithari ,
            Butwal, Birgunj, Nepalgunj, Bhaktapur, Jitpur Simara, Parwanipur and
            Janakpur . The top 10 job roles in demand include: construction
            skilled worker, construction helper, marketing and sales, delivery
            boy, cook, office staff, factory worker, cleaner, entry level
            cashier cum accountant. We are partnering with a large number of
            businesses in the country to effectively match demand for labor with
            employment seekers. For updated details, please visit Rojgari’s
            website:<a target="_blank" href="https://rojgari.com/"
              >https://rojgari.com/</a
            >
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            How will job seekers benefit from this Campaign--from Rojgari and
            सीप’s support?
          </div>
          <div class="is-size-8 has-text-justified">
            Jobseekers can access services for <b>FREE</b>. Service package
            includes: soft skills counselling by Rojgari Services followed by
            facilitation/linkage to services like skilling, jobs, f inance,
            enterprise start -up services via other training providers,
            industries, Government, NGOs, and financial institutions. Job
            seekers can register their personal data via Rojgari’s website or
            App from anywhere in the world. This will help Rojgari analyse job
            seeker’s profile so that the subsequent employment pathway can be as
            tailored and targeted. Job seekers can also contact Rojgari Services
            via Facebook messenger, landline, Viber, WhatsApp, or visit Rojgari
            Pasals or Ghumti Rojgari Pasal.
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            Rojgari’s website (rojgari.com) and mobile application (search
            Rojgari in app/play store) are simple, and user-friendly. For
            tutorial on how to use the application, please visit:
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=AYOOk2yx_KU"
              >https://www.youtube.com/watch?v=AYOOk2yx_KU</a
            >. Decision to hire ultimately lies with those businesses that have
            expressed an interest in recruiting qualified jobseekers.
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            Do registered jobseekers get placed in employment or linked to
            enterprise services immediately after they register?
          </div>
          <div class="is-size-8 has-text-justified">
            Rojgari Services plays the role of a connector and facilitator to
            bridge the gap between job seekers and industries/Government. Based
            on a quick analysis of the skills, needs, and interests of the job
            seekers, Rojgari, then, coordinates with relevant, appropriate
            partners -- either training providers, industries, Government, NGOs,
            or f inancial institutes -- to place and create appropriate
            employment/self-employment pathways for the target group. This
            process typically takes anywhere f rom 1 week to 1 month according
            to skill of job seeker and job demand or business opportunity
            available in the market. To follow-up on their status, job seekers
            can see details of job or business available in rojgari.com or can
            contact via
            <a target="_blank" href="https://rojgari.com/contact"
              >https://rojgari.com/contact</a
            >
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            How can Employers/Industries and Training Providers add their worker
            demands or services in Rojgari’s system?
          </div>
          <div class="is-size-8 has-text-justified">
            Employers can register in the system via
            <a target="_blank" href="https://rojgari.com/sign-in"
              >https://rojgari.com/sign-in</a
            >
            and then search for the right candidates/job seekers registered in
            Rojgari’s database as per their requirements. Employers can either
            post a job using a Self -service option, which will allow them to
            receive applications from job seekers and coordinate the selection
            process on their own. They also have the option of seeking Job
            Matching service f rom Rojgari Service to get the support they need
            to f ind the right candidate(s). Employers can also choose Staff
            Outsourcing service from Rojgari Service, if they wish to outsource
            their entire HR f unction and/or payroll for their full-time,
            part-time or temporary natured jobs. For more information on how to
            access and benefit from Rojgari’s Services, contact: Bindu Thapa:
            9802050683,
            <a href="mailto:bindu.thapa@rojgari.com">bindu.thapa@rojgari.com</a>
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            <b>Training providers</b> can list their services by registering in
            <a target="_blank" href="https://rojgari.com/sign-in"
              >https://rojgari.com/sign-in</a
            >
            and sending an email to
            <a href="mailto:info@rojgari.com">info@rojgari.com</a>.
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            Who is Rojgari Services and why are they well-equipped to deliver on
            this initiative?
          </div>
          <div class="is-size-8 has-text-justified">
            Rojgari Services is a service provider and part of the Merojob group
            of companies. It connects job seekers with information and services
            related to access to career counselling, soft skills orientation,
            vocational training – on-the-job at employers or via training
            institutes – and employment match-making. To date, Rojgari Services
            has facilitated jobs for over 10,000 youth through a network of
            nearly 4,000 employers.
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            Who is UKaid सीप and what role does it play?
          </div>
          <div class="is-size-8 has-text-justified">
            The four-year UKaid Skills for Employment Programme (सीप) is
            brokering transformational partnerships with the Nepali private and
            public sector to propel growth in selected priority sectors –
            commercial agriculture, light manufacturing, tourism, ICT, and
            construction – primarily in Provinces 2 and 5 through expanded
            access to quality skilling linked to gainful employment/self -
            employment and migration optimization.
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            Since April 2019, UKaid सीप, in coordination with the Government of
            Nepal, DFID, industries, and civil society, is working with private
            sector-led initiatives to expand and strengthen opportunities for
            job seekers and enable industry growth in the process. For further
            details on सीप:
            <a target="_blank" href="http://www.seepnepal.com/"
              >http://www.seepnepal.com/</a
            >
          </div>
        </div>
      </div>
      <div
        v-else
        class="columns is-multiline has-padding-left-60-desktop has-padding-right-60-desktop has-padding-left-30-mobile has-padding-right-30-mobile has-padding-top-20 has-padding-bottom-10"
      >
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            'अब देशमै छ रोजगारी' अभियान भनेको के हो र यो कसको लागि लक्षित छ?
          </div>
          <div class="is-size-8 has-text-justified">
            ‘अब देशमै छ रोजगारी’ अभियान जुलाई ३०, २०२० मा रोजगारी सर्भिसेस र सीप
            (UKaid Skills for Employment Programme) द्वारा शुरू गरिएको एक
            नेतृत्व पहल हो । यस अभियानको उद्देश्य बैदेशिक रोजगारीबाट फर्केका,
            बिपन्न तथा अन्य सामाजिक वन्चितिकरणमा परेका समूहहरु सम्म पुगी
            उनीहरुको नाम दर्ता गरेर नेपालमै रोजगारी प्रदान गर्नु हो । दुई प्रमुख
            लक्ष्यहरू यस प्रकार छन्:
          </div>
          <div class="is-size-8 has-text-justified pl-4">
            <ul style="list-style-type: disc">
              <li>
                रोजगारी खोज्नेहरूको डाटाबेस तयार गर्न र रोजगारी / स्व-रोजगारीका
                अवसरहरूको लागि रोजगारी
                <a target="_blank" href="https://rojgari.com/">वेवसाइट</a> र
                मोबाइल एप्लिकेसनद्वारा विदेशबाट फर्किएका व्यक्तिहरुको विवरण
                दर्ता गर्ने ।
              </li>
              <li>
                नेपाल सरकार, उद्योगहरू / रोजगारदाता, सहकारी, प्रशिक्षण प्रदायक,
                वित्तीय संस्था, नागरिक समाज, र अन्यहरू बीचको सहकार्यमा गुणस्तर,
                सीप बिकास , रोजगारी , वित्तीय सहयोग, उद्यम सुचारु गर्ने अवसरहरु
                उपलब्ध गराइ आर्थिक बृद्धि गर्ने ।
              </li>
            </ul>
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            अभियानका लागि प्राथमिक लक्षित श्रोताहरू रोजगारी खोज्नेहरू हुन्,
            विशेष गरी आप्रवासीहरू जो प्रदेश २ र ५ मा फर्केका छन्, र
            अन्तर्राष्ट्रिय सीमाना खुल्दा आसन्न फिर्ताको सामना गरिरहेका छन्।
            यस्तै महत्वपूर्ण, यो अभियान इकोसिस्टम सरोकारवालाहरू ( नेपाल सरकार,
            रोजगारदाता / उद्योगहरू, वित्तीय संस्था, प्रशिक्षण प्रदायक, उद्यम
            स्टार्ट-अप सेवा प्रदायक, मेडिया / प्रभावकारीहरू, गैरसरकारी
            संस्थाहरू) लाई लक्षित गरिएको छ जससँग बैदेशिक रोजगारबाट फर्किएका
            व्यक्तिहरुलाई संलग्न गराउने क्षमता र सहयोगको लागि प्रोत्साहन गरिन्छ
            ।
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            यो अभियान नेपालमा रोजगारी / स्वरोजगार / उद्यमशीलता अवसरमा विदेशबाट
            फर्केका व्यक्तिहरूलाई जानकारी दिन र आकर्षित गर्न, तथा निजी क्षेत्र र
            सरकारका लागि रोजगारी सर्भिसेस र सीप जस्ता साझेदारहरूको सहयोगमा
            रोजगार सिर्जना गर्ने र सूचित गर्ने दुबैमा सहयोग पुर्‍याउन डिजाइन
            गरिएको हो। "अब देशमै छ रोजगारी" नाराको माध्यमबाट विदेशबाट
            फर्कनेहरूका लागि घरेलु रोजगारलाई ध्यान दिन आवश्यक पर्ने विश्वासलाई
            जगाउनुको साथसाथै उद्योग / रोजगारदाताहरूमा रोजगारी सर्भिसेसको महत्व
            चिनाई एकअर्का संग हात मिलाएर काम गर्ने हो | हाम्रो लक्ष्य भनेको
            नेपालका जनशक्तिहरुको लागि र द्वारा रोजगारी सिर्जना गर्नु र उद्यम
            वृद्धिको लागि सामूहिक अभियानलाई उत्प्रेरित गर्नु हो ।
          </div>
        </div>

        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            “अब देशमै छ रोजगारी” अभियान किन आवश्यक छ?
          </div>
          <div class="is-size-8 has-text-justified">
            अर्को वर्ष मात्र लगभग ७००००० नेपाली कामदारहरू वैदेशिक रोजगारबाट
            फर्कने अनुमान गरिएको छ। धेरै जना थोरै बचतका साथ भबिस्यको सानो योजना
            बनाएर केहि महिनापछि नेपाल फर्किदै छन्। अनुमान गरे अनुसार बेरोजगारीको
            संकटबाट बच्नको लागि नेपालले १५ लाख रोजगारी सिर्जना गर्नु आवश्यक छ।
            सरकारले निजी क्षेत्रसँग मिलेर विदेशबाट फर्केका व्यक्तिहरूलाई ठूलो
            संख्यामा लाभदायक रोजगारी / स्वरोजगारको लागि व्यवस्था गर्न आवस्यक छ।
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            हाम्रो व्यक्तिगत र सामूहिक असमर्थता भएको खण्डमा यसको प्रभाव
            अर्थव्यवस्था को सबै क्षेत्रहरुमा विपरित प्रभाव पर्न सक्छ। तसर्थ यस
            अभियानले विदेशबाट फर्केका व्यक्तिहरू सम्म पुग्न र दर्ताको लागि
            प्रोत्साहन गर्न आबस्यक सहयोग र सेवाको लागि सहकार्य बढाइ देशमा
            “न्यानो स्वागत” बिस्तार गर्दछ। त्यसो गर्दा देशका नागरिकहरू, उद्यमहरू
            र अर्थतन्त्रको विकासलाई बढावा दिन हामी सँगै मिलेर हाम्रो मानवीय
            पूंजीको लाभ उठाउन सक्षम छौं भन्ने कुरा सुनिश्चित गर्छ।
          </div>
        </div>

        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            अभियान कसरी विदेशबाट फर्किएका व्यक्तिहरू सम्म पुग्न सक्दछ?
          </div>
          <div class="is-size-8 has-text-justified">
            बहु-च्यानल, एकीकृत संचार र जीविकोपार्जन अभियान प्रयोग गरेर हामी
            विदेशबाट फर्किएका अर्धदक्ष र दक्ष कामदारहरुलाई परामर्श गर्दछौ र अन्य
            साझेदारहरूसंग सम्पर्क गराउछौ। यो अभियानले रोजगारी सर्भिसेसको नेटवर्क
            र सेवाहरुलाई मजबूत बनाएर जतिसक्दो धेरै लक्षित समूहसम्म पुग्न जोड
            गर्दछ।
          </div>
          <div class="is-size-8 has-text-justified pl-4">
            <ul style="list-style-type: disc">
              <li>
                <b>डिजिटल इन्गेजमेन्ट र मिडिया आउटरीच </b> – फेसबुक (<a
                  target="_blank"
                  href="https://www.linkedin.com/company/rojgari-services-pvt-ltd/"
                  >रोजगारी सर्भिसेस</a
                >
                ,
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/ukaid-skills-for-employment-programme-%E0%A4%B8%E0%A5%80%E0%A4%AA/?originalSubdomain=np"
                  >UKaid सीप</a
                >, अन्य सहयोगीहरू), यूट्यूब विज्ञापन, भाइबर, अनलाइन मिडिया,
                वेबिनार / छलफल (फेसबुक र लिंकेडीन), टिकटक, साथै रेडियो र प्रिन्ट
                मिडिया।
              </li>
              <li>
                धुर्मुस र सुन्तली जस्ता
                <b>प्रभावकारीहरूलाई संलग्न गराउँदै </b> उनीहरूको सार्वजनिक
                प्लेटफर्महरू मार्फत अभियानलाई समर्थन र साझेदारी गर्छ।
              </li>
              <li>
                पौरखी नेपाल, प्रवासी नेपाली समन्वय समिति, आप्रवासी महिला कामदार
                समूह जस्ता गैरसरकारी संस्थाहरूको सहयोगमा गन्तव्य मुलुकहरूमा
                <b>च्याम्पियनहरु संलग्न गराएर</b> आप्रवासीहरुबाट दर्ता गराउछ र
                सहज बनाउछ।
              </li>
              <li>
                निजी क्षेत्र, सरकार, मिडिया र नागरिक समाजमा
                <b>सहयोगीहरूलाई अभियानको समर्थन र विस्तार गर्नको</b> लागि
                उनीहरूको सार्वजनिक प्लेटफर्महरू जस्तै शोरूम, कार्यालयहरू,
                एटीएमहरू, सामाजिक मिडिया प्लेटफर्महरू, मिडिया लेखहरू, इत्यादिमा
                संलग्न गराउछ।
              </li>
              <li>
                सिप र रोजगारी सर्भिसेसद्वारा संचालित
                <b>घुम्ती रोजगारी पसल </b>मार्फत जागिर खोज्नेहरु को विवरण दर्ता
                गर्न ग्रामीण क्षेत्रको कुना- कुनामा यात्रा जारी गर्नेछ।
                प्राथमिकता प्रदेश २ र प्रदेश ५ मा रहनेछ।
              </li>
              <li>
                रोजगारी सर्भिसेसको बीरगंज, नेपालगन्ज, काठमाडौं, पोखरा र इटहरीमा
                पनि<b>रोजगारी पसलहरु</b> छन्। यी रोजगारी पसलहरूले रोजगार
                खोज्नेहरू र रोजगारदाताहरूलाई सम्पर्क गराउछ।
              </li>
            </ul>
          </div>
        </div>

        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            यो अभियान कसरी नेपाल सरकारको प्रयासको पूरक छ?
          </div>
          <div class="is-size-8 has-text-justified">
            यो "अब देशमै छ रोजगारी" अभियान जनता, संस्था, र नेपाल सरकारलाई थप
            रोजगारी सिर्जना गर्न, उद्यमशील व्यवसाय, र सामाजिक-आर्थिक बृद्धि गर्न
            सामूहिक अभियान उत्प्रेरित गरि सहयोग गर्ने उद्देश्यले डिजाइन गरिएको
            हो। रोजगारी सर्भिसेस र सीप ,२०१९ देखि नेपाल सरकारसँग अर्थपूर्ण
            सहकार्यको लागि प्रदेश २ र ५ मा काम गर्दैछ विशेष गरी प्रदेश सरकार,
            नगरपालिका, स्थानीय वडा र रोजगार सेवा केन्द्र (ESCs)। उदाहरणका लागि
            रोजगारी सर्भिसेस रजिस्ट्रेशन पोर्टल , र त्यहाँ दर्ता भएका व्यक्तिहरू
            सरकारबाट उपलब्ध सहयोग / सेवामा लिंक हुनेछन्। त्यसैगरी, रोजगारी
            सर्भिसेसले रोजगारीको वेब र मोबाइल एप्लिकेसनहरू मार्फत आउने
            व्यक्तिहरुलाई निजी क्षेत्रको नेतृत्वमा सीप र रोजगारी अवसरहरूमा
            सम्पर्क गराउन रोजगार सेवा केन्द्रहरूलाई राजगारी खोज्नेहरुको विवरण
            दर्ता गर्न अनुरोध तथा प्रोत्साहित गर्दछ।
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            संघीय स्तरमा यस अभियानले श्रम, रोजगार, र सामाजिक सुरक्षा मन्त्रालय
            लगायत अन्य सम्बन्धित सरकारी कार्यक्रमलाई साथसाथै एकीकृत गर्नेछ र
            देशको दृष्टिकोणलाई समर्थन गर्न र विदेशबाट फर्कनेहरूका लागि रोजगारी
            सिर्जना गर्नका लागि प्रयत्न गर्नेछ।
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            के देशमा रोजगारी सर्भिसेस, सीप, र अन्य साझेदारहरूको अभियानमा डेलिभर
            गर्न पर्याप्त रोजगार छन्?
          </div>
          <div class="is-size-8 has-text-justified">
            पछिल्लो महिनामा मात्र, रोजगारी सर्भिसेसले लगभग ९००० रोजगार / मागहरू
            संकलन गरेको छ। यी मध्ये अधिकांश काठमाडौं, इटहरी, बुटवल, वीरगन्ज,
            नेपालगन्ज, भक्तपुर, जितपुर, सिमरा, पर्वाणीपुर र जनकपुरमा रहेका छन्।
            प्रमुख १० कामहरु यस प्रकार छन्: निर्माण दक्ष कामदार, निर्माण सहयोगी,
            मार्केटिंग र सेल्स, डेलिभरी गर्ने व्यक्ति, कुक, अफिस स्टाफ, कारखाना
            कामदार, सफा गर्ने, लेखापाल। रोजगार खोजीकर्ताहरूसँग श्रमको मागलाई
            मिलाउन हामी देशका धेरै संख्यामा व्यवसायहरूसँग साझेदारी गर्दैछौं। थप
            विवरणहरूका लागि, कृपया रोजगारीको वेबसाइट भ्रमण गर्नुहोस्:<a
              target="_blank"
              href="https://rojgari.com/"
              >https://rojgari.com/</a
            >
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            रोजगार खोजी गर्नेहरूले कसरी यस अभियानबाट फाइदा लिन सक्दछन् - रोजगारी
            र सीपको सहयोगबाट?
          </div>
          <div class="is-size-8 has-text-justified">
            रोजगार खोजी गर्नेहरू <b>निःशुल्क</b> रुपमा सेवाहरू पहुँच गर्न
            सक्दछन्। सर्भिसेस प्याकेजले यी कुराहरु समावेश गर्दछ: रोजगारी
            सर्भिसेसहरु द्वारा अन्य तालिम प्रदायकहरू, उद्योगहरू, सरकार,
            गैरसरकारी संस्थाहरू, र वित्तीय संस्थाहरू मार्फत सफ्ट स्किल्स परामर्श
            पछाडि स्किलिंग, रोजगार, सुविधा / लिंकजस्ता सेवाहरू जस्तै स्किलिंग,
            रोजगार, वित्तीय, ईन्टरप्राइज स्टार्ट-अप सेवाहरू । रोजगार खोज्नेहरूले
            रोजगारीको वेबसाइट वा एप्लिकेसन मार्फत विश्वको कुनै पनि ठाउँमा आफ्नो
            व्यक्तिगत विवरण दर्ता गर्न सक्दछन्। यसले रोजगारी सर्भिसेसलाई रोजगारी
            खोजीकर्ताको प्रोफाइलको विश्लेषण गर्न मद्दत पुर्‍याउँछ ताकि त्यसपछिको
            रोजगारी मार्ग अनुरूप हुन्छ र लक्षित हुन सकिन्छ। रोजगार खोज्नेहरूले
            फेसबुक मेसेन्जर, ल्यान्डलाइन, भाइबर, व्हाट्सएप, अथवा रोजगारी पसल वा
            घुम्ती रोजगारी पसल मार्फत पनि रोजगारी सेर्भिसेसमा सम्पर्क गर्न
            सक्दछन्।
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            रोजगारीको वेबसाइट (rojgari.com) र मोबाइल एप्लिकेसन (प्ले स्टोरमा
            रोजगारी एप्लिकेसन खोज्नुहोस्) सरल, र प्रयोगकर्ता-मैत्री छन्। कसरी
            एप्लिकेसनको उपयोग गर्ने बारे ट्यूटोरियलका लागि कृपया यहाँ जानुहोस्:
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=AYOOk2yx_KU"
              >https://www.youtube.com/watch?v=AYOOk2yx_KU</a
            >। नियुक्त गर्ने निर्णय अन्ततः ती संस्थाहरूमा निहित छ जसले योग्य
            कामदारको माग गरेका छन्।
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            के दर्ता गरे लगत्तै रोजगार खोजिकर्ताहरुले जागिर पाउछन् वा
            इन्टरप्राइज सेवाहरूमा लिंक हुन्छन्?
          </div>
          <div class="is-size-8 has-text-justified">
            रोजगारी सर्भिसेसले रोजगारी खोज्नेहरू र उद्योगहरू / सरकार बीच एक
            कनेक्टर र सहजकर्ताको भूमिका खेल्दछ। रोजगार खोज्नेहरूको सीप,
            आवश्यकता, र चासोहरूको द्रुत विश्लेषणको आधारमा रोजगारीले प्रासंगिक,
            उपयुक्त साझेदारहरू - तालिम प्रदायक, उद्योग, सरकार, गैरसरकारी संस्था
            वा वित्तीय संस्थामा लक्षित समूहको लागि उपयुक्त रोजगार / स्वरोजगार
            मार्गहरू सिर्जना गर्न समन्वय गर्दछ। । रोजगारी खोज्नेहरु को सीप र
            उपलब्ध अवसरको आधारमा यो प्रक्रिया सामान्यतया जहाँसुकै पनि १ हप्ता
            देखि १ महिनासम्म लाग्छ। फलो-अपको लागि, रोजगार खोजी गर्नेहरूले
            rojgari.com मा उपलब्ध रोजगार वा व्यवसायको विवरणहरू हेर्न सक्छन् वा
            <a target="_blank" href="https://rojgari.com/contact"
              >https://rojgari.com/contact</a
            >
            मार्फत सम्पर्क गर्न सक्दछन्।
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            रोजगारदाता / उद्योग र तालिम प्रदायकहरूले कसरी रोजगारी सर्भिसेसको
            सिस्टममा उनीहरूका कामदारहरूको माग वा सेवाहरू थप्न सक्दछन्?
          </div>
          <div class="is-size-8 has-text-justified">
            रोजगारदाताहरूले
            <a target="_blank" href="https://rojgari.com/sign-in"
              >https://rojgari.com/sign-in</a
            >
            मार्फत दर्ता गर्न सक्दछन् र उनीहरूको आवश्यकता अनुसार रोजगारीको
            डाटाबेसमा दर्ता भएका उम्मेदवारहरू / रोजगारी खोज्नेहरूलाई चयन गर्न
            सक्दछन्। रोजगारदाताहरूले स्व-सेवा विकल्प प्रयोग गरेर रोजगार पोस्ट
            गर्न सक्दछन्, जसले उनीहरूलाई रोजगार खोज्नेहरूबाट आवेदनहरू प्राप्त
            गर्न अनुमति दिनेछ र चयन प्रक्रिया पनि आफैले गर्नेछन्। अर्को विकल्पको
            रुपमा उनीहरुले रोजगारी सेर्भिसेसको सहायतामा पनि सहि उम्मेदवार पाउन
            सक्नेछन्। रोजगारदाताहरूले रोजगारी सर्भिसेसबाट स्टाफ आउटसोर्सिंग सेवा
            पनि प्रयोग गर्न सक्दछन्, यदि उनीहरूले आफ्नो सम्पूर्ण समय, आंशिक वा
            अस्थायी कामहरूको लागि उनीहरूको सम्पूर्ण HR function र / वा payroll
            आउटसोर्स गर्न चाहे भने। थप जानकारीको लागि सम्पर्क गर्नुहोस्: बिंदु
            थापा: ९८०२०५०६८३,
            <a href="mailto:bindu.thapa@rojgari.com">bindu.thapa@rojgari.com</a>
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            <b>तालिम प्रदायकहरूले </b>
            <a target="_blank" href="https://rojgari.com/sign-in"
              >https://rojgari.com/sign-in</a
            >
            मा दर्ता गरेर र
            <a href="mailto:info@rojgari.com">info@rojgari.com</a> मा ईमेल पठाएर
            आफ्नो सेवाहरू सूचीबद्ध गर्न सक्दछन्।
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            रोजगारी सर्भिसेस को हो र यो यस पहलमा पुर्‍याउन किन राम्रोसँग
            सुसज्जित छन्?
          </div>
          <div class="is-size-8 has-text-justified">
            रोजगारी सर्भिसेस एक सेवा प्रदायक र merojob कम्पनीको हिस्सा हो। यसले
            काम गर्ने स्थलमै तालिम, तालिम केन्द्र र जब म्याचिंग मार्फत रोजगार
            खोजी गर्नेहरूलाई क्यारियर परामर्श, सफ्ट स्किल्स अभिमुखीकरण,
            व्यावसायिक प्रशिक्षण जस्ता सूचना र सेवाहरूसँग जोड्दछ। आजको दिनसम्म,
            रोजगारी सर्भिसेसले लगभग ४००० रोजगारदाताहरूको नेटवर्कमार्फत १०,०००
            भन्दा बढी युवाहरूको लागि रोजगारीको सुविधा पुर्‍याएको छ।
          </div>
        </div>
        <div class="column is-12">
          <div class="has-text-weight-bold has-text-jobseeker mb-2">
            UKaid सीप को हो र यसले के भूमिका खेल्छ?
          </div>
          <div class="is-size-8 has-text-justified">
            UKaid Skills for Employment Programme (सीप) चार वर्षदेखि रोजगारीका
            लागि चयन गरेको विशेष गरी प्रदेश नं. २ र ५ का प्राथमिक क्षेत्रहरू
            (व्यावसायिक कृषि, विधुतीय सामाग्री उत्पादन , इन्फर्रमेशन एण्ड
            कम्युनिकेसन टेकनोलोजी, र निर्माण ) विकास गर्न लाभदायक रोजगारी /
            स्वरोजगार र माइग्रेसन अप्टिमाइजेसनसँग जोडिएको गुणस्तरीय स्किलिंग को
            विस्तारित पहुँचको माध्यमबाट नेपाली निजी र सार्वजनिक क्षेत्रको साथ
            परिवर्तनकारी साझेदारी गर्दै आएको छ।
          </div>
          <div class="is-size-8 has-text-justified mt-2">
            अप्रिल २०१९ देखि, UKaid सीपले नेपाल सरकार, DFID, उद्योगहरू, र नागरिक
            समाजको समन्वयमा, रोजगारी खोज्नेहरूका लागि अवसरहरूको विस्तार र
            सुदृढीकरण गर्न र उद्योगको विकास सक्षम पार्न निजी क्षेत्रको अगुवाईमा
            पहल गर्दै आएको छ। थप विवरणहरूको लागि:
            <a target="_blank" href="http://www.seepnepal.com/"
              >http://www.seepnepal.com/</a
            >
          </div>
        </div>
      </div>

      <div
        v-if="$route.path === '/en/sep-faqs'"
        class="columns is-multiline pb-5 has-padding-left-70-desktop has-padding-right-70-desktop has-padding-left-30-mobile has-padding-right-30-mobile"
      >
        <div class="column is-12 mt-3 has-light-background">
          <div class="is-size-8 has-text-centered">
            <b
              >For more information on Rojgari Services: Sanjib Kumar
              Niraula,</b
            >
            <a href="mailto:sanjib.niraula@rojgari.com"
              >sanjib.niraula@rojgari.com</a
            >, <b>9802075544</b>
          </div>
          <div class="is-size-8 has-text-centered">
            <b>For media inquiries related to UKaid सीप: Ayusha Nirola,</b>
            <a href="mailto:ayusha.nirola@seepnepal.com"
              >ayusha.nirola@seepnepal.com</a
            >, <b>9851126033</b>
          </div>
        </div>
      </div>
      <div
        v-else
        class="columns is-multiline pb-5 has-padding-left-70-desktop has-padding-right-70-desktop has-padding-left-30-mobile has-padding-right-30-mobile"
      >
        <div class="column is-12 mt-3 has-light-background">
          <div class="is-size-8 has-text-centered">
            <b>रोजगारी सर्भिसेस सम्बन्धित थप जानकारीका लागि: सन्जिब निरौला,</b>
            <a href="mailto:sanjib.niraula@rojgari.com"
              >sanjib.niraula@rojgari.com</a
            >, <b>९८०२०७५५४४</b>
          </div>
          <div class="is-size-8 has-text-centered">
            <b>UKaid सीप सम्बन्धित मिडिया जिज्ञासाहरूका लागि: आयुषा निरोला,</b>
            <a href="mailto:ayusha.nirola@seepnepal.com"
              >ayusha.nirola@seepnepal.com</a
            >, <b>९८५११२६०३३ </b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  head() {
    return {
      title: 'अब देशमै छ रोजगारी FAQs | Rojgari'
    }
  }
}
</script>
<style scoped>
.has-light-background {
  background: rgb(237, 242, 243);
}
.is-size-8 {
  font-size: 0.85rem;
}
</style>
